module.exports = __webpack_public_path__ + "img/logo_secogey - copia.709ec3d7.png";